import React, { useEffect, useRef, useState } from 'react'
import ScheduleProWrapper from '../../../../../../SmartSchedule/SchedulePro/ScheduleProWrapper'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { smartScheduleSelector } from '../../../../../../../../redux/reducers/reducerSlices/SmartScheduleReducer';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { sagaActions } from '../../../../../../../../sagas/sagaActions';
import { getUserSelector } from '../../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { AppConstant } from '../../../../../../../Assests/AppConstant';
import AppointmentReportSummarySubHeader from './Components/AppointmentReportSummarySubHeader';
import { CustomPaginationSS } from '../../../../../../Common/CustomPaginationSS/CustomPaginationSS';
import DrilldownTableSS from '../../../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableSS';
import { getRemoteConfigSelector } from '../../../../../../../../redux/reducers/reducerSlices/RemoteConfigReducer';
import moment from 'moment';
import _ from 'lodash'
import WarehouseSearchSS from '../../../../../../SuperWarehouse/Components/SearchWarehouse/WarehouseSearchSS';
import ModalSS from '../../../../../../SmartSchedule/SchedulePro/Components/Common/ModalSS/ModalSS';
import AppointmentReportHistory from './Components/AppointmentReportHistory';
import './AllAppointmentsListSS.css';
import UploadSproDocumentsPopup from '../../../../../../Common/UploadSproDocumentsPopup/UploadSproDocumentsPopup';
import PoDetailsPopup from '../../../../../../Common/PoDetailsPopup/PoDetailsPopup';
import { getLocalDateString } from '../../../../../../../../Utils/DateUtils';
import { getPoSSselector } from '../../../../../../../../redux/reducers/reducerSlices/POSmartSchedulerReducer';
import { shouldHavePermission } from '../../../../../../../Assests/Utility';
import CustomDropDown from '../../../../../../Common/CustomDropDown/CustomDropDown';

/**
 * Reusable drill down report for appointment summary
 * @param {*} props 
 * @returns 
 */
const DrillDownAppointmetReportSummary = (props) => {
    const { themeSelected } = props;
    const {groupByType, startDate, endDate} = useParams();
    const location = useLocation();
    const _searchParams = new URLSearchParams(location.search);
    const _queryWhId = _searchParams.get('whId');
    const _queryWhName = _searchParams.get('whName');
    const _hasWarehouseParam = _searchParams.has('whName');
    const ss = useSelector(smartScheduleSelector);
    const { initateLoading, appointmentDocumentsList } = ss;
    const pOSS = useSelector(getPoSSselector);
    const { myAppointmentsListResponse } = pOSS;
    const dispatch = useDispatch();
    const userPermission = useSelector(getUserSelector);
    const { selectedWarehouse, userType, cu_id, permissions, userAccountDetails } = userPermission;
    const [selectedStartDate,setSelectedStartDate] = useState(null)
    const [selectedEndDate,setSelectedEndDate] = useState(null)
    const remoteConfig = useSelector(getRemoteConfigSelector);
    const { allConfigration } = remoteConfig;
    const { PaginationDefaultLimit } = allConfigration;
    const [allApptsArr, setAllApptsArr] = useState([]);
    const [searchStr, setSearchStr] = useState('');
    const first=useRef(true)
    const navigate = useNavigate();
    const [showAppointmentHistoryModal, setShowAppointmentHistoryModal] = useState(false);
    const [apptNumber, setapptNumber] = useState(null);
    const [showUploadDocsModal, setShowUploadDocsModal] = useState(false)
    const [showPoDetailsModal, setShowPoDetailsModal] = useState(false)
    const [selectedPo, setSelectedPo] = useState(null);
    const [allowPermission, setAllowPermission] = useState(false);
    const [currentWarehouseFilterSelected, setCurrentWarehouseFilterSelected] = useState(
        _hasWarehouseParam
            ? { ID: _queryWhId || null, name: decodeURIComponent(_queryWhName || 'All Warehouse') }
            : null
    );
    const [currentUserTypeFilterSelected, setCurrentUserTypeFilterSelected] = useState(() => {
        if (groupByType === 'warehouse') return { name: 'Warehouse' };
        if (groupByType === 'carrier') return { name: 'Carrier' };
        return { name: 'All User' };
    });

    /**
     * useEffect to check warehouse management permission
     */
    useEffect(() => {
        if (permissions && permissions.length) {
            const warehouseManagementPermission = _.find(permissions, { 'FeatureID': '12', 'PageAccess': true });
            if (warehouseManagementPermission && !_.isEmpty(warehouseManagementPermission)) {
                let temp = shouldHavePermission(permissions, '1000');
                setAllowPermission(temp);
                // Only set default 'All Warehouse' if no warehouse was pre-populated from query params
                if (temp && !_hasWarehouseParam) {
                    setCurrentWarehouseFilterSelected({ ID: null, name: 'All Warehouse' });
                }
            }
        }
    }, [permissions]);

    /**
     * useEffect to reset appointments list on mount/unmount
     */
    useEffect(() => {
        dispatch({ type: sagaActions.RESET_APPTS_LIST_ACTION });
        return () => {
            dispatch({ type: sagaActions.RESET_APPTS_LIST_ACTION });
        };
    }, []);

    /**
     * useEffect to form appointments data
     */
    useEffect(() => {
        if (myAppointmentsListResponse && myAppointmentsListResponse?.data && myAppointmentsListResponse?.data?.length) {
            setAllApptsArr(myAppointmentsListResponse.data)
        } else {
            setAllApptsArr([])
        }

    }, [myAppointmentsListResponse])

    /**
 * useEffect to set start date in redux
 */
    useEffect(() => {
        if(selectedStartDate){
            dispatch({ type: sagaActions.UPDATE_START_DATE, payload: selectedStartDate })
        }
    },[selectedStartDate])

/**
 * useEffect to set end date in redux
 */
    useEffect(() => {
        if (selectedEndDate) {
            dispatch({type:sagaActions.UPDATE_END_DATE, payload:selectedEndDate})
        }
    },[selectedEndDate])


    /**
     * useEffect to handle startDate and endDate
     */
    useEffect(()=>{
        if (startDate!='null' && endDate!='null') {
            setSelectedStartDate(new Date(startDate))
            setSelectedEndDate(new Date(endDate))
        }else{
            setSelectedStartDate(null)
            setSelectedEndDate(null)
        }
  
    }, [startDate, endDate])
    
    /**
     * useEffect to fetch data once start or end date is modified, or warehouse filter changes
     */
    
    useEffect(() => {
        if (selectedStartDate && selectedEndDate) {
            fetchApptByType()
        }
    },[selectedStartDate, selectedEndDate, currentWarehouseFilterSelected, currentUserTypeFilterSelected])

    // /**
    //  * useEffect to call fetch appointment by groupby type (warehosue/carrier)
    //  */
    // useEffect(()=>{
    //     if (groupByType) {
    //         setTimeout(()=>{
    //         fetchApptByType()
    //     },[0])
    //     }
    // },[groupByType])

    /**
     * useEffect to handle search 
     */
    useEffect(()=>{
        if (first.current) {
            first.current=false
            return
        }
        else{
            if (searchStr.length>=4) {
                setTimeout(()=>{
                    fetchApptByType()
                },[1000])
            }else if(searchStr===''){
                fetchApptByType()
            }
            
        }
    }, [searchStr])

    useEffect(() => {
        if (showUploadDocsModal) {
           fetchUploadDocsDataForAppt()
        }

    }, [showUploadDocsModal])

    const fetchUploadDocsDataForAppt = () => {
        if (apptNumber) {
            dispatch({type: sagaActions.INTIATE_SS_LOADER, payload: true})
            let fd = new FormData();
            fd.append('AppointmentNumber', apptNumber)
            fd.append('file', null); // Assuming 'file' is the file object
            fd.append('docName', null); // Append the document name
            fd.append('ApptDocsCreatedBy', null);
            fd.append('ApptDocsUpdatedBy', null);
            fd.append('CRUDTYPE', 'S');
            dispatch({
                type: sagaActions.UPLOAD_APPT_DOCS,
                payload: {
                    CRUDTYPE: 'S',
                    uploadData: fd
                }
            });
        }
    }

    const documentModelHandler = (el) => {
        if (showUploadDocsModal) {
            setapptNumber(null)
        } else {
            setapptNumber(el?.AppointmentNumber)
        }
        setShowUploadDocsModal(!showUploadDocsModal)
    }

    const toggleModal = () => {
        setShowAppointmentHistoryModal(!showAppointmentHistoryModal);
    }

    /**
     * Function to fetch appt data using getAppointmentReportDetails API
     * @param {*} pageNo 
     * @param {*} limit 
     */
    const fetchApptByType=(pageNo=1,limit=PaginationDefaultLimit)=>{
        const apiParams = {
            "ID": allowPermission ? (currentWarehouseFilterSelected?.ID || null) : selectedWarehouse.ID,
            "type": 'warehouse',
            "pageNo": pageNo,
            "limit": limit,
            "searchParam": searchStr ? searchStr : null,
            "StartDate": selectedStartDate ? getLocalDateString(selectedStartDate) : null,
            "EndDate": selectedEndDate ? getLocalDateString(selectedEndDate) : null,
            "ApptStatus": "All",
            "UserTypeFilter": currentUserTypeFilterSelected?.name === 'All User' ? null : currentUserTypeFilterSelected?.name,
            "CompanyID": allowPermission ? (currentWarehouseFilterSelected?.ID ? null : selectedWarehouse.CompanyID) : null
        }
        dispatch({ type: sagaActions.MY_APPTS_LIST_ACTION, payload: apiParams })
    }

    /**
     * used for the appointment report user type filter
     * @returns
     */
    const showCustomDropDownForUserTypeFilter = () => {
        const filterDataArr = [
            { name: 'All User' },
            { name: 'Carrier' },
            { name: 'Warehouse' }
        ]
        return (
            <div className='d-flex align-items-center ms-2'>
                <CustomDropDown themeSelected={themeSelected} data={filterDataArr} placeHolder={currentUserTypeFilterSelected?.name} onSelect={(event) => setCurrentUserTypeFilterSelected(event)} keyStr={'name'} />
            </div>
        )
    }

    const getApptSchStatusColor = (str) => {
        if (str.toLowerCase() === 'completed') {
            return <p className='text-success'>{str}</p>
        } else if (str.toLowerCase() === 'scheduled') {
            return <p className='text-danger'>{str}</p>
        } else {
            return <p className='notScheStatusText'>{str}</p>
        }
    }


    const apptsTitleDDWH = [
        { id: 'serial_num', name: 'S.No' },
        { id: 'ApptNumber', name: 'Appt Number' },
        { id: 'PoNumber', name: 'PO' },
        { id: 'CarrierName', name: 'Carrier' },
        { id: 'WarehouseName', name: 'Warehouse' },
        { id: 'DueDate', name: 'Due Date' },
        { id: 'ApptStartTime', name: 'Appt Date & Time' },
        { id: 'DockName', name: 'Dock' },
        { id: 'Pallets', name: 'Pallets' },
        { id: 'ItemsCases', name: AppConstant.smartScheduler.poSection.cases  },
        { id: 'ApptScheStatus', name: 'Status' },
        { id:'uploadDocs', name: 'Actions' },
        { id: 'Accordion', name: 'Multi PO' },
    ]

    const getActions=(el)=>{
        return(
            <div className='d-flex justify-content-evenly'>
            <span onClick={() => documentModelHandler(el)}><i className="fa-solid fa-file text-grey fa-lg" title='Show Attachments'></i></span>
            <span onClick={() => {
                setSelectedPo(el)
                setShowPoDetailsModal(true)
            }}><i className="fa-solid fa-circle-info text-grey fa-lg" title='Show More Details'></i></span>

            </div>
        )
    }

    /**
     * Function to form data for table
     * @param {*} data 
     * @returns 
     */
    const formatDrillDownData = (data) => {
        return _.isArray(data) && data.map((el,index) => {
            return {
                    id: el.RoleID,
                    0: index + 1,
                    1:  <span style={{textDecoration: 'underline',color: 'blue'}} onClick={() => fetchApptsReportHistoryDetails(el.AppointmentNumber)}>{el.AppointmentNumber}</span>,
                    2: el.PoNumber,
                    3: el.CarrierName || '-',
                    4: el.WarehouseNameWithExternalSiteID || '-',
                    5: moment(el.DueDate).utc().format('MM/DD/YYYY') || '-',
                    6: moment(el.ApptStartTime).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') || '-',
                    7: el.DockName || '-',
                    8: el.Pallets || '-',
                    9: el.ItemsCases || '-',
                    10: el.ApptScheStatus ? getApptSchStatusColor(el.ApptScheStatus) : '-',
                    11: getActions(el)
                }
        })
    }

    /**
     * Function to form data for multi po
     * @param {*} data 
     * @returns 
     */
    const formatdata = (data) => {
        let result = data?.map(el => {
            if (el?.associatedPO && el?.associatedPO.length) {
                return [el, ...el?.associatedPO]
            } else {
                return [el]
            }
        })
        return result;
    }

    /**
     * Higher order function to form data for table
     * @returns 
     */
    const getBodyData = () => {
        if (allApptsArr.length) {
            const formatedData = formatdata(allApptsArr);
            return (formatedData.map((data, index) => {
                return (
                    formatDrillDownData(data, index)
                )
            }))
        }
        else {
            return []
        }
    }

    /**
     * Function to handle page change
     * @param {*} pageNo 
     * @param {*} limit 
     */
    const pageChange = (pageNo, limit = PaginationDefaultLimit) => {
        fetchApptByType(pageNo, limit)
    }

    const fetchApptsReportHistoryDetails = (apptNumber) => {
        setapptNumber(apptNumber)
        setShowAppointmentHistoryModal(true)
    }

  return (
    <ScheduleProWrapper showAppointments={false}>
        <div className='appointments-report-ss-wrapper p-3'>
            <div className='d-flex align-items-center justify-content-between' style={{ gap: '8px', minWidth: 0 }}>
            
                <span className='f-16 fw-semobold d-flex align-items-center gap-2' style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>{<i className="fa-solid fa-arrow-left pointer" onClick={()=>navigate(-1)}></i>} {AppConstant.appointmentReportSummary.header}{` / ${groupByType}`}</span>
                <div className='d-flex align-items-center' style={{ minWidth: 0 }}>
                <AppointmentReportSummarySubHeader
                    getData={fetchApptByType}
                    selectedStartDate={selectedStartDate}
                    setSelectedStartDate={setSelectedStartDate}
                    selectedEndDate={selectedEndDate}
                    setSelectedEndDate={setSelectedEndDate}
                    isDrillDown={true}
                    subRoot={groupByType}
                    allowPermission={allowPermission}
                    currentWarehouseFilterSelected={currentWarehouseFilterSelected}
                    setCurrentWarehouseFilterSelected={setCurrentWarehouseFilterSelected}
                    themeSelected={themeSelected}
                />
               
             
             
                    {/* showCustomDropDownForUserTypeFilter() */}
                    <div className='pos-rel ps-2'>
                        <WarehouseSearchSS
                            placeholder={AppConstant.poManagement.searchPOSection.searchTitleStr}
                            inputValue={searchStr}
                            cancelSearch={() => setSearchStr('')}
                            onChangeHandler={(text) => setSearchStr(text)} />
                    </div>
                    </div>
                    </div>
               <p className='text-danger mb-0 text-end' style={{ fontSize: 'small' }}>{AppConstant.appointmentReportSummary.dateFilterDisclaimer}</p>
               <br/>
               <br/>
               <div className='appt-summary-list-ss'>
               {myAppointmentsListResponse &&
        <DrilldownTableSS
            themeSelected={themeSelected}
            key={Math.random()}
            sortKey={true}
            showUTCTime={true}
            bodyData={getBodyData()}
            titleData={apptsTitleDDWH}
            showCollapse={false}
            hasCollapsableContent={true}
            collapsableData={allApptsArr.length?formatdata(allApptsArr):[]}
            accordionPrimaryIndex={1}
            showInput={true}
            showSort={false}
            arrangeOrder={null}
            arrangeKey={null}
            drillDownReport={allApptsArr}
            initiateDrillDownReport={initateLoading}
            loaderArray={13}
        />
        }
        </div>
        {!_.isEmpty(myAppointmentsListResponse) && myAppointmentsListResponse?.data?.length ?
             
             <CustomPaginationSS
                 pageNo={myAppointmentsListResponse?.pageNo}
                 pageSize={myAppointmentsListResponse?.limit}
                 first={myAppointmentsListResponse?.first}
                 last={myAppointmentsListResponse?.last}
                 totalElements={myAppointmentsListResponse?.totalElements}
                 totalPages={myAppointmentsListResponse?.totalPages}
                 pageChange={(pageNo, limit) => { pageChange(pageNo, limit) }}
             />
          : ""
              }
              {showAppointmentHistoryModal &&
                        <ModalSS toggleModal={toggleModal}>
                            <AppointmentReportHistory  
                            themeSelected={themeSelected}
                            data={apptNumber}
                            />
                        </ModalSS>
              }
               {showUploadDocsModal ? <UploadSproDocumentsPopup showModal={showUploadDocsModal} setCloseModal={setShowUploadDocsModal} uploadDocsHandler={() => {}} docDeleteHandler={() => {} } appointmentDocumentsList={appointmentDocumentsList} showDelete={false} showUpload={false} initateLoading={initateLoading} /> : ''}
               {showPoDetailsModal ? <PoDetailsPopup showModal={showPoDetailsModal} setCloseModal={setShowPoDetailsModal} poData={{...selectedPo,WarehouseData:selectedPo.WarehouseDetails}} initateLoading={initateLoading} /> : ''}

     </div>
    </ScheduleProWrapper>
  )
}

export default DrillDownAppointmetReportSummary